import React, {Fragment} from "react";
import {connect} from "react-redux";
import {compose} from "recompose";
import styles from "./styles";
import {isEmpty, camelCase} from "lodash";
import "./styles.css";
import {
  withStyles,
  Button,
  TextField,
  Typography,
  Card,
  CardContent,
  CardActions,
  Checkbox
} from "@material-ui/core";
import SafeLogo from "../../assets/images/horizontal-enterprise2.png";
import eyeON from "../../assets/images/eye-on.png";
import eyeOFF from "../../assets/images/eye-off.png";
import Loading from "../../components/Loading";
import {openSnackBar} from "../../actions/snack-bar";
import {login, register, sendPin} from "../../actions/authentication";
import update from "immutability-helper";
// import { setVisibility } from '../../actions/message-drawer'
import LoadingButton from "../../components/LoadingButton";
import classNames from "classnames";
import Fade from "@material-ui/core/Fade";
import FormControl from "@material-ui/core/FormControl";
import Input from "@material-ui/core/Input";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import Grid from "@material-ui/core/Grid";
//import InputGroup from "@material-ui/core/InputGroup";
// import MaskedInput from 'react-text-mask'
import {version} from "../../../package.json";
import {TextMaskCustom} from "../../components/MaskedInput";
//import { uploadImage, sendPhotoID } from "../../actions/avatarImage";
import LicenseImageUpload from "../../components/LicenseImageUpload";
import {formatPhoneNumber} from "../../utils";
import constant from "../../config/constant";
import {sumterSubscribe} from '../../actions/subscribe';

// import Register from '../../components/Register'
// const { version } = { packageJson }

// TODO PIN MODAL

let duration = 0;
class FaceSnap extends React.Component {
  state = {
    isLoading: false, //! CHANGE FOR ANIMATION
    loginPhone: "",
    loginPassword: "",
    registerFirstName: "",
    registerLastName: "",
    registerEmail: "",
    registerPhone: "",
    registerPassword: "",
    registerCode: "",
    registerCountry: "US",
    forms: {},
    isRegister: true,
    isEnterprise: "TRUE",
    isPin: false,
    is_premium: 0,
    pay_method: "NA",
    pinSent: false,
    inputType: "password",
    eyeType: eyeON,
    displayOp: "none",
    displayCode: "",
    colorLen: "red",
    colorLow: "red",
    colorCap: "red",
    colorNum: "red",
    pin: [
      "", "", "", ""
    ],
    delay: "register",
    role: "user",
    spin: false,
    userVerified: false
  };


  componentDidMount() {
    let {authenticatedUser} = this.props.authentication;
    const {contacts} = authenticatedUser;
    if (!isEmpty(authenticatedUser) && !isEmpty(contacts)) {
      this.props.history.push(`/showings`);
    } else if (!isEmpty(authenticatedUser) && authenticatedUser.phone) {
      this.setState({
        loginPhone: formatPhoneNumber(authenticatedUser.phone.substring(2))
      });
      this.verifyAccount();
    }

    if (isEmpty(authenticatedUser)) {
      this.setLoading();
    }

    this.setUpForms();
  }

  setLoading = () => {
    this.setState({timeout: setTimeout(() => {
        this.setState({isLoading: false});
        this.setUpForms();
      }, 3800)});
  };
  componentWillUnmount() {
    clearTimeout(this.state.timeout);
  }
  setUpForms = () => {
    const forms = document.querySelectorAll("form");
    forms.forEach(form => {
      const formName = camelCase(form.id);
      const inputs = form.getElementsByTagName("input");
      let newState = update(this.state, {});
      if (!newState.forms[formName]) {
        newState.forms[formName] = {};
      }
      for (let i = 0; i < inputs.length; ++i) {
        newState.forms[formName][inputs[i].name] = {
          validity: inputs[i].validity
        };
      }
      newState.forms[formName].valid = this.formIsValid(newState.forms[formName]);
      this.setState(newState);
    });
  };
  clearForms = () => {
    this.setState({
      loginPhone: "",
      loginPassword: "",
      registerFirstName: "",
      registerLastName: "",
      registerEmail: "",
      registerPhone: "",
      registerPassword: "",
      registerCode: "",
      isEnterprise: "TRUE",
      userVerified: false
    });
  };

  handleInputChange = e => {
    const fieldName = e.target.name;
    const value = e.target.value;
    const validity = e.target.validity;
    const formName = camelCase(e.target.form.id);
    let newState = update(this.state, {
      [fieldName]: {
        $set: value
      },
      forms: {
        [formName]: {
          [fieldName]: {
            validity: {
              $set: validity
            }
          }
        }
      }
    });
    newState.forms[formName].valid = this.formIsValid(newState.forms[formName]);
    this.setState(newState);
  };

  handleRadioButton = e => {
    const value = e.target.value;
    this.setState({role: value});
  };

  handlePhoneInputChange = (formName, fieldName, value) => {
    const validity = document.getElementById(fieldName).validity;

    let newState = update(this.state, {
      [fieldName]: {
        $set: value
      },
      forms: {
        [formName]: {
          [fieldName]: {
            validity: {
              $set: validity
            }
          }
        }
      }
    });
    newState.forms[formName].valid = this.formIsValid(newState.forms[formName]);
    this.setState(newState);
  };

  handleInputBlur = e => {
    const fieldName = e.target.name;
    let newState = update(this.state, {
      forms: {
        [camelCase(e.target.form.id)]: {
          [fieldName]: {
            touched: {
              $set: true
            }
          }
        }
      }
    });
    this.setState(newState);
  };

  formIsValid = form => {
    let formValidArray = [];
    for (let key in form) {
      if (key !== "valid") {
        formValidArray.push(form[key].validity.valid);
      }
    }
    return formValidArray.indexOf(false) === -1;
  };
  afterLogin = response => {
    console.log(this.props, 'props')
    if (response && response.role && response.role === "buyer") {
      this.props.history.push(`/buyer-profile`);
    } else if (this.props.location.state && this.props.location.state.hasOwnProperty("redirect")) {
      this.props.history.push(this.props.location.state.redirect);
    } else if (!isEmpty(this.props.authentication.authenticatedUser.contacts)) {
      this.props.history.push(`/showings`);
    } else if (this.props.authentication.authenticatedUser.registerCode === "SBOR01092001" || this.props.authentication.authenticatedUser.registerCode === "Free4Me"){
      //this.state.isEnterprise = "TRUE"
      //this.state.is_premium = 1
      //this.state.pay_method = "SPAY"
      this.props.dispatch(sumterSubscribe(this.props.authentication.authenticatedUser.id)).then((res) => {
        console.log(res);
        this.props.history.push(`/magic`);
      }).catch((err) => {
        console.log(err);
      });
      //this.props.history.push('/magic')
    } else {
      localStorage.setItem("registerCode", this.props.authentication.authenticatedUser.registerCode);
      this.props.history.push(`/checkout`);
    }

    // console.log('RhasPass', response, response.has_password)

    if (!response.has_password) {
      this.props.dispatch(openSnackBar({message: "Please enter a password to make login easier in the future"}));
    }
  };

  doLogin = e => {
    console.log(this.state, 'this.state')
    e.preventDefault();
    let {loginPhone: phone, loginPassword: password} = this.state;
    if (phone === '') {
      this.props.dispatch(openSnackBar({message: "Please enter a valid phone number"}));
    } else {
      phone = "+1" + phone.replace(/\D/g, "");
      let type = 'WEB'
      this.props.dispatch(login({phone, password, type})).then(response => {
        this.afterLogin(response);
        // console.log('RESSSS', response)
      }).catch(err => {
        let bool = true;
        console.log("ERRRRR", err, err.type, err.message);
        let message = "There was an error logging in"; //CATCH ALL
        if (err.type === "not found") {
          message = "Account not found"; // 404
        } else if (err === "The password was wrong") {
          // TODO where do this come from (just err)
          // TODO err.type ==="pass"

          message = "Password was incorrect";
        } else if (err === "account is blocked") {
          message = "Your account has been blocked please contact to admin.";
        } else if (err === "account not verified") {
          message = "The account is not verified";
          setTimeout(() => {
            this.verifyAccount();
          }, 200);
        } else if (err.message === "missing credentials") {
          // TODO user in db but no pass made ,sends a password at login (db is missing creds, not leaving password field empty)
          message = "You already have a FaceSnap Enterprise account. Please click Forgot Password";
          bool = false;
        }
        if (bool) {
          this.props.dispatch(openSnackBar({message}));
        } else {
          this.forgotLogin(true);
        }
      });
    }
  };

  checkPW = (pw) => {
    if (pw.length < 7) {
      return "Your password needs a minimum of 7 characters"
    } else if (pw.search(/[a-z]/) < 0) {
      return "Your password needs a lower case letter"
    } else if(pw.search(/[A-Z]/) < 0) {
      return "Your password needs an uppser case letter"
    } else  if (pw.search(/[0-9]/) < 0) {
      return "Your password needs a number"
    } else {
      return "TRUE"
    }
  }

  doRegister = e => {
    e.preventDefault();
    let {
      registerPhone: phone,
      registerPassword: password,
      registerFirstName: first_name,
      registerLastName: last_name,
      registerEmail: email,
      registerCode: registerCode,
      isEnterprise: isEnterprise,
      is_premium: is_premium,
      pay_method: pay_method,
      role: role
    } = this.state;
    console.log(this.state)
    console.log(registerCode)
    console.log(this.state.registerCode)
    if (phone.length !== 14) {
      this.props.dispatch(openSnackBar({message: "Please enter a valid phone number"}));
      return;
    } else if (first_name.trim().length < 1) {
      this.props.dispatch(openSnackBar({message: "Please enter a first name"}));
      return;
    } else if (last_name.trim().length < 1) {
      this.props.dispatch(openSnackBar({message: "Please enter a last name"}));
      return;
    } else if (registerCode != "ROGX50082001" && registerCode != "ATIT50092001"
              && registerCode != "NCAR01092001" && registerCode != "RBAR01092001"
              && registerCode != "SCAR01092001" && registerCode != "COMPcode"
              && registerCode != "SBOR01092001" && registerCode != "WARE01092001"
              && registerCode != "CAOR010092001" && registerCode != "Free4Me"
              && registerCode != "OHAR01102001" && registerCode != "NMEX01012001") {
      this.props.dispatch(openSnackBar({message: "Code is Invalid"}));
      return;
    } else if (this.state.role !== "buyer" && !/^(([^<>()[\]\\.,;:\s@']+(\.[^<>()[\]\\.,;:\s@']+)*)|('.+'))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)) {
      this.props.dispatch(openSnackBar({message: "Please enter a valid email"}));
      return;
    } else if (this.checkPW(password) != "TRUE") {
      let message = this.checkPW(password)
      this.props.dispatch(openSnackBar({message: message}));
      return;
    }
    phone = "+1" + phone.replace(/\D/g, "");
    const requestData = {
      phone,
      password,
      first_name,
      last_name,
      email,
      isEnterprise,
      is_premium,
      pay_method,
      registerCode,
      countryCode: this.state.registerCountry,
      role
    };

    this.props.dispatch(register(requestData)).then(response => {
      this.clearForms();
      this.setState({
        loginPhone: formatPhoneNumber(response.phone.substring(2))
      });
      this.verifyAccount();
      localStorage.setItem("registerCode", this.state.registerCode)
    }).catch(err => {
      // TODO maybe redirect to pinsent page? or instruct them to login via phone (see comment below)
      console.log("Error for Page Here")
      let message = "There was an error with your registration";
      if(err != undefined) {
        if (err.message === "users create error") {
          if (err.error.code === "ER_DUP_ENTRY") {
            if (err.error.sqlMessage.indexOf("for key 'phone'") > -1) {
              message = "You already have a FaceSnap Enterprise account"; // TODO ASK ABOUT old one -- 'That phone number is already in our system'
            }
          }
        } 
      } else {
        console.log("Origin Blocked")
        message = "Oops. Something went wrong..."
      }
      this.props.dispatch(openSnackBar({message}));
    });
  };

  verifyAccount = () => {
    localStorage.clear();
    this.setState({isPin: true, isRegister: false, userVerified: true});
    this.handlePin();
  };

  getDelay = formName => {
    return this.state.delay === formName
      ? duration + 100
      : 0;
  };

  forgotLogin = bool => {
    this.setState({isPin: true});
    setTimeout(() => {
      if (!this.state.forms.hasOwnProperty("pinForm")) {
        this.setUpForms();
      }
    }, 230);
    if (bool) {
      this.props.dispatch(openSnackBar({message: "Test"}));
      this.handlePin();
    }
  };

  handlePinInputChange = e => {
    const index = parseInt(e.target.name, 10);
    const value = e.target.value.slice(0, 1);
    let arr = this.state.pin;
    arr.splice(index, 1, value);
    this.setState(update(this.state, {
      pin: {
        $set: arr
      }
    }));
    if (value) {
      const nextInput = document.getElementById(`pinInput${index + 1}`);
      if (nextInput) {
        nextInput.focus();
      }
    }
  };

  handlePinKeyPress = e => {
    const index = parseInt(e.target.name, 10);
    if (e.keyCode === 8 && this.state.pin[index] === "") {
      const prevInput = document.getElementById(`pinInput${index - 1}`);
      if (prevInput) {
        prevInput.focus();
      }
    }
  };

  resendPin = () => {
    this.props.dispatch(sendPin("+1" + this.state.loginPhone.replace(/\D/g, ""))).then(() => {
      this.props.dispatch(openSnackBar({message: "Pin number resent"}));
    });
  };

  quietPin = () => {
    //resends pin with no snackbar message ;)
    this.props.dispatch(sendPin("+1" + this.state.loginPhone.replace(/\D/g, ""))).then(() => {
    });
  };

  handlePin = e => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    this.setState({sendingPin: true});
    if (this.state.pinSent) {
      const loginReq = {
        phone: "+1" + this.state.loginPhone.replace(/\D/g, ""),
        auth_code: this.state.pin.join(""),
        type: 'WEB'
      };
      console.log(loginReq)
      if (this.state.userVerified) {
        loginReq["userVerified"] = true;
      }
      this.props.dispatch(login(loginReq)).then(res => {
        this.setState({sendingPin: false});
        this.afterLogin(res);
      }).catch(err => {
        // User does not exists
        console.log(err)
        if (err.type === "not found") {
          this.props.dispatch(openSnackBar({message: "No account with that number found"}));
        } else if (err.type === undefined) {
          this.quietPin()
          this.props.dispatch(openSnackBar({message: "Please enter your pin that was sent to your phone"}));
        } else {
          this.props.dispatch(openSnackBar({message: "Pin number was incorrect"}));
        }
        this.setState({sendingPin: false});
      });
    } else {
      this.props.dispatch(sendPin("+1" + this.state.loginPhone.replace(/\D/g, ""))).then(() => {
        this.setState({sendingPin: false, pinSent: true});
      }).catch((err = "no_error_502") => {
        // TODO NOT GETTING AN ERR, HAD TO DEFAULT ERR
        console.log("eeeee", err);
        if (err && err.message && err.message.indexOf("for user id #null") > -1) { // TODO Changed) {
          this.props.dispatch(openSnackBar({message: "No account with that number found"}));
        } else if (err && err.message && err.message.indexOf("missing outgoing sms number") > -1) { //TODO changed) {
          this.props.dispatch(openSnackBar({message: "Could not text pin number"}));
        } else if (err && err.message && err.message.indexOf("twilio create error") > -1) { //TODO changed) {
          this.props.dispatch(openSnackBar({message: "This is not a valid phone number."}));
        } else {
          this.props.dispatch(openSnackBar({message: "There was an error texting pin number"}));
        }

        this.setState({sendingPin: false, pinSent: false});
      });
    }
  };
  validateForm() {
    return ((!isEmpty(this.state.forms.registerForm) && !this.state.forms.registerForm.valid && !this.state.checked) || this.state.spin);
  }
  showHide = (e) => {
     e.preventDefault();
     e.stopPropagation();
     this.setState({
      inputType: this.state.inputType === 'input' ? 'password' : 'input',
      eyeType: this.state.eyeType === eyeOFF ? eyeON : eyeOFF
     })
   }
   changeDisplay = (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.setState({
       displayOp: this.state.displayOp === 'none' ? 'inline' : 'none'
      })
    }
    displayOff = (e) => {
       e.preventDefault();
       e.stopPropagation();
       this.setState({
        displayOp: this.state.displayOp = 'none'
       })
     }

    checkReqs = (e) => {

      this.setState({[e.target.name]: e.target.value})
      if(e.target.value.length > 7 && e.target.value.length < 16) {
        this.state.colorLen = "green"
      } else {
        this.state.colorLen = "red"
      }
      if(e.target.value.match(/[0-9]/g)) {
        this.state.colorNum = "green"
      } else {
        this.state.colorNum = "red"
      }
      if(e.target.value.match(/[a-z]/g)) {
        this.state.colorLow = "green"
      } else {
        this.state.colorLow = "red"
      }
      if(e.target.value.match(/[A-Z]/g)) {
        this.state.colorCap = "green"
      } else {
        this.state.colorCap = "red"
      }
    }
  render() {
    const {classes} = this.props;

    const {isLoading, isRegister} = this.state;
    duration = this.props.theme.transitions.duration.shorter;

    //fill in code box from link
    var otherval = window.location.href.split("code=");
    if (otherval[1] == "ROGX50082001" || otherval[1] == "ATIT50092001"
        || otherval[1] == "NCAR01092001" || otherval[1] == "RBAR01092001"
        || otherval[1] == 'SCAR01092001' || otherval[1] == "SBOR01092001"
        || otherval[1] == 'WARE01092001' || otherval[1] == "CAOR010092001"
        || otherval[1] == 'Free4Me' || otherval[1] == "OHAR01102001"
        || otherval[1] == 'NMEX01012001') {
      this.state.registerCode = otherval[1];
      this.state.displayCode = "none";
    }
    return (<div className={classes.app}>
      {
        isLoading
          ? (<Loading/>)
          : (<Fragment>
            <span className={classes.header}>
              <img src={SafeLogo} alt="Safe" className={classes.safeLogo}/>

            </span>

            <Card classes={{
                root: classNames(classes.cardWrapper, {
                  [classes.isRegister]: isRegister
                })
              }}>
              <div className={classNames(classes.formGroup, {
                  [classes.loginForm]: !isRegister,
                  [classes.registerForm]: isRegister
                })}>
                {
                  !this.state.isRegister && (<div
                    // centered
                    duration={duration} delay={this.getDelay("login")} direction="left">
                    <div style={{
                        display: "flex",
                        justifyContent: "center"
                      }}>
                      {
                        this.state.isPin && (<Fade in="in">
                          <form className={classNames(this.props.classes.form)} id="pin-form" noValidate="noValidate" autoComplete="off" onSubmit={this.handlePin}>
                            <CardContent classes={{
                                root: this.props.classes.cardContentRoot
                              }}>
                              {
                                !this.state.pinSent && (<TextField autoFocus="autoFocus" name="loginPhone" type="tel" id="loginPhone" label="Mobile Phone" className={classes.textField} margin="normal" value={this.state.loginPhone} onChange={e => this.handlePhoneInputChange("pinForm", "loginPhone", e.target.value)} InputProps={{
                                    inputComponent: TextMaskCustom
                                  }}/>)
                              }
                              {
                                this.state.pinSent && (<Fragment>
                                  <Typography variant="body1">
                                    {
                                      `Pin number has been sent to
																		${this.state.loginPhone} enter it below to
																		login`
                                    }
                                  </Typography>
                                  <div className={this.props.classes.pinInputWrapper
}>
                                    <FormControl fullWidth="fullWidth" className={this.props.classes.pinInput}>
                                      <Input type="tel" fullWidth="fullWidth" inputProps={{
                                          required: true,
                                          className: this.props.classes.pinInputInput
                                        }} name="0" value={this.state.pin[0]} onChange={this.handlePinInputChange} onKeyDown={this.handlePinKeyPress} id="pinInput0" autoComplete="nope" style={{
                                          maxWidth: "50px"
                                        }} autoFocus="autoFocus"/>
                                    </FormControl>
                                    <FormControl fullWidth="fullWidth" className={this.props.classes.pinInput}>
                                      <Input type="tel" fullWidth="fullWidth" inputProps={{
                                          required: true,
                                          className: this.props.classes.pinInputInput
                                        }} name="1" value={this.state.pin[1]} onChange={this.handlePinInputChange} onKeyDown={this.handlePinKeyPress} id="pinInput1" autoComplete="nope" style={{
                                          maxWidth: "50px"
                                        }}/>
                                    </FormControl>
                                    <FormControl fullWidth="fullWidth" className={this.props.classes.pinInput}>
                                      <Input type="tel" fullWidth="fullWidth" inputProps={{
                                          required: true,
                                          className: this.props.classes.pinInputInput
                                        }} name="2" value={this.state.pin[2]} onChange={this.handlePinInputChange} onKeyDown={this.handlePinKeyPress} id="pinInput2" autoComplete="nope" style={{
                                          maxWidth: "50px"
                                        }}/>
                                    </FormControl>
                                    <FormControl fullWidth="fullWidth" className={this.props.classes.pinInput}>
                                      <Input type="tel" fullWidth="fullWidth" inputProps={{
                                          required: true,
                                          className: this.props.classes.pinInputInput
                                        }} name="3" value={this.state.pin[3]} onChange={this.handlePinInputChange} onKeyDown={this.handlePinKeyPress} id="pinInput3" autoComplete="nope" style={{
                                          maxWidth: "50px"
                                        }}/>
                                    </FormControl>
                                  </div>
                                </Fragment>)
                              }
                            </CardContent>
                            <CardActions classes={{
                                root: this.props.classes.actionsRoot
                              }}>
                              <Button color="secondary" disabled={!this.state.pinSent} onClick={this.resendPin} type="button">
                                Send Again
                              </Button>
                              <LoadingButton color="secondary" working={this.state.sendingPin} disabled={this.state.pinSent
                                  ? this.state.pin.join("").length !== 4
                                  : !isEmpty(this.state.forms.pinForm) && !this.state.forms.pinForm.valid
} type="submit">
                                Submit
                              </LoadingButton>
                            </CardActions>
                          </form>
                        </Fade>)
                      }
                      {
                        !this.state.isPin && (<Fade in="in">
                          <form id="login-form" noValidate="noValidate" autoComplete="off" onSubmit={this.doLogin} style={{
                              maxWidth: "500px"
                            }}></form>
                        </Fade>)
                      }
                    </div>
                  </div>)
                }
                {
                  this.state.isRegister && (<div
                    // centered
                    duration={duration} delay={this.getDelay("register")} direction="left">
                    <form className={classNames(this.props.classes.form)} id="register-form" noValidate="noValidate" autoComplete="off" onSubmit={this.doRegister} style={{
                        display: "flex",
                        justifyContent: "center"
                      }}>
                      <CardContent classes={{
                          root: this.props.classes.cardContentRootRegister
                        }} style={{
                          maxWidth: "700px"
                        }}>
                        <Grid container="container" spacing={16}>
                          <Grid item="item" xs={12} sm={6}>
                            <FormControl fullWidth="fullWidth">
                              <InputLabel htmlFor="registerPhone">
                                Mobile Phone
                              </InputLabel>
                              <Input type="tel" onFocus={this.displayOff} fullWidth="fullWidth" inputProps={{
                                  required: true
                                }} name="registerPhone" id="registerPhone" value={this.state.registerPhone} onChange={e => this.handlePhoneInputChange("registerForm", "registerPhone", e.target.value)} inputComponent={TextMaskCustom} onBlur={this.handleInputBlur} autoComplete="nope"/>
                            </FormControl>
                          </Grid>
                          <Grid item="item" xs={12} sm={6}>
                            <FormControl fullWidth="fullWidth">
                              <InputLabel htmlFor="registerFirstName">
                                First Name
                              </InputLabel>
                              <Input type="text" onFocus={this.displayOff} fullWidth="fullWidth" inputProps={{
                                  required: true
                                }} name="registerFirstName" value={this.state.registerFirstName} onChange={this.handleInputChange} onBlur={this.handleInputBlur} id="registerFirstName" autoComplete="nope"/>
                            </FormControl>
                          </Grid>
                          <Grid item="item" xs={12} sm={6}>
                            <FormControl fullWidth="fullWidth">
                              <InputLabel htmlFor="registerLastName">
                                Last Name
                              </InputLabel>
                              <Input type="text" onFocus={this.displayOff} fullWidth="fullWidth" inputProps={{
                                  required: true
                                }} name="registerLastName" value={this.state.registerLastName} onChange={this.handleInputChange} onBlur={this.handleInputBlur} id="registerLastName" autoComplete="nope"/>
                            </FormControl>
                          </Grid>
                          {
                            this.state.role !== "buyer" && (<Grid item="item" xs={12} sm={6}>
                              <FormControl fullWidth="fullWidth">
                                <InputLabel htmlFor="registerEmail">
                                  Email
                                </InputLabel>
                                <Input type="email" onFocus={this.displayOff} fullWidth="fullWidth" inputProps={{
                                    required: true
                                  }} name="registerEmail" value={this.state.registerEmail} onChange={this.handleInputChange} onBlur={this.handleInputBlur} id="registerEmail" autoComplete="nope"/>
                              </FormControl>
                            </Grid>)
                          }
                          <Grid item="item" xs={12} sm={this.state.role !== "buyer"
                              ? 12
                              : 6}>
                              <FormControl>
                                <div class="container" display="inline-block" justifyContent="center" alignItems="center">
                                  <InputLabel htmlFor="registerPassword">
                                    Password
                                  </InputLabel>
                                  <Input type={this.state.inputType} fullWidth="fullWidth" inputProps={{required: true}}
                                     name="registerPassword" value={this.state.registerPassword} onChange={this.handleInputChange, this.checkReqs}
                                     onBlur={this.handleInputBlur} id="registerPassword" autoComplete="nope" onFocus={this.changeDisplay}
                                     />
                                     <img src={this.state.eyeType} onClick={this.showHide} height="20px" width="30px" style={{margin: '16px 0 0 8px' }}/>
                                </div>
                                <ul class="input-requirements" style={{display: this.state.displayOp}}>
                                  <li class="reqLen" style={{color: this.state.colorLen}}>At least 8 characters long (and less than 15 characters)</li>
                                  <li class="reqNum" style={{color: this.state.colorNum}}>Contains at least 1 number</li>
                                  <li class="reqLow" style={{color: this.state.colorLow}}>Contains at least 1 lowercase letter</li>
                                  <li class="reqCap" style={{color: this.state.colorCap}}>Contains at least 1 uppercase letter</li>
                                </ul>
                              </FormControl>
                          </Grid>
                          <Grid item="item" xs={12} sm={this.state.role !== "buyer"
                              ? 12
                              : 6}>
                            {
                              <FormControl fullWidth="fullWidth"  style={{display: this.state.displayCode}}>
                                  <InputLabel htmlFor="registerCode">
                                    Code
                                  </InputLabel>
                                  <Input type="text" onFocus={this.displayOff} fullWidth="fullWidth" inputProps={{
                                      required: true
                                    }} name="registerCode" value={this.state.registerCode} onChange={this.handleInputChange} onBlur={this.handleInputBlur} id="registerCode" autoComplete="nope"/>
                                </FormControl>
                            }
                          </Grid>
                        </Grid>
                        <div>
                          <a href="https://thefacesnap.com/terms-and-conditions/" style={{
                              color: "#000000"
                            }}>
                            Agree to Terms
                          </a>
                          <Checkbox required="required" checked={this.state.checked} color="primary" onChange={() => this.setState({
                              checked: !this.state.checked
                            })
}/>
                        </div>
                        <Grid item="item" xs={12} sm={12} className={this.props.classes.registerButtonsWrapper}>

                          <LoadingButton color="primary" working={this.props.authentication.registering} className={this.props.classes.buttonReg} disabled={this.validateForm()} type="submit">
                            Proceed
                          </LoadingButton>
                        </Grid>
                      </CardContent>
                    </form>
                  </div>)
                }
              </div>

              <div style={{
                  position: "fixed",
                  top: "97%",
                  left: "2%",
                  color: "#d3d3d3"
                }}>
                {version}
              </div>
            </Card>
          </Fragment>)
      }
    </div>);
  }
}

const mapStateToProps = state => {
  return {authentication: state.authentication};
};
export default compose(connect(mapStateToProps), withStyles(styles, { withTheme: true }))(FaceSnap);
